import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Section, Field, CoverField, GalleryField, ModuleOrderEditor, PluginTogglesSection, FaqEditor, GiftCardsEditor, WorkingHoursField, LocationEditor, PromotionsEditor } from './TemplateFields';
import { OnlineOrderingSettings, MenuCategoriesEditor, TableReservationEditor } from './MenuModules';
import { orderedSections } from '../../data/businessCatalog';

export default function MenuEditor({ storeTab, mc, setMc, upload, uploading, pluginOn, togglePlugin, availPlugins }) {
  return (
    <div className="space-y-8">
      {storeTab === 'identity' && (<>
        <Section title="Pamatinformācija">
          <Field label="Sauklis / apraksts">
            <Input value={mc.tagline || ''} onChange={(e) => setMc({ tagline: e.target.value })}
              placeholder="Piem. Mājas virtuve Rīgas sirdī" className="bg-white/5 border-white/10 text-white" data-testid="menu-tagline" />
          </Field>
          <Field label="Dienas piedāvājums">
            <Input value={mc.daily_special || ''} onChange={(e) => setMc({ daily_special: e.target.value })}
              placeholder="Piem. Zupa + otrais + dzēriens 6.90€" className="bg-white/5 border-white/10 text-white" data-testid="menu-daily-special" />
          </Field>
          <CoverField url={mc.cover_url} uploading={uploading} onUpload={(f) => upload(f, (u) => setMc({ cover_url: u }))} testid="menu-cover-upload" />
        </Section>

        <OnlineOrderingSettings mc={mc} setMc={setMc} />
      </>)}

      {storeTab === 'build' && (<>
        <PluginTogglesSection available={availPlugins} plugins={mc.plugins} onToggle={togglePlugin} template="menu" />
        <ModuleOrderEditor template="menu" order={orderedSections('menu', mc.module_order)} onChange={(v) => setMc({ module_order: v })} />
      </>)}

      {storeTab === 'content' && (<>
        <MenuCategoriesEditor mc={mc} setMc={setMc} upload={upload} />

        {pluginOn('tables') && <TableReservationEditor mc={mc} setMc={setMc} />}

        {pluginOn('gift_cards') && (
          <GiftCardsEditor data={mc} onChange={setMc} />
        )}

        {pluginOn('gallery') && (
          <GalleryField gallery={mc.gallery} onAdd={(f) => upload(f, (u) => setMc({ gallery: [...mc.gallery, u] }))} onRemove={(i) => setMc({ gallery: mc.gallery.filter((_, j) => j !== i) })} />
        )}

        {pluginOn('promotions') && (
          <PromotionsEditor promotions={mc.promotions || []} onChange={(v) => setMc({ promotions: v })} />
        )}

        {pluginOn('hours') && (
          <WorkingHoursField value={mc.working_hours} onChange={(v) => setMc({ working_hours: v })} />
        )}

        {pluginOn('map') && (
          <LocationEditor address={mc.address} lat={mc.lat} lng={mc.lng} onPatch={(p) => setMc(p)} />
        )}

        {pluginOn('faq') && <FaqEditor faq={mc.faq} onChange={(v) => setMc({ faq: v })} />}

        <Section title="Kontakta piezīme">
          <Textarea value={mc.contact_note || ''} onChange={(e) => setMc({ contact_note: e.target.value })}
            placeholder="Piem. Grupām lūdzam zvanīt iepriekš." className="bg-white/5 border-white/10 text-white" data-testid="menu-note" />
        </Section>
      </>)}
    </div>
  );
}
